/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Deleteaccount1Inputs */

const zh_danger_deleteaccount1 = /** @type {(inputs: Danger_Deleteaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除账户`)
};

const en_danger_deleteaccount1 = /** @type {(inputs: Danger_Deleteaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Account`)
};

const es_danger_deleteaccount1 = /** @type {(inputs: Danger_Deleteaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

/**
* | output |
* | --- |
* | "Delete Account" |
*
* @param {Danger_Deleteaccount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_deleteaccount1 = /** @type {((inputs?: Danger_Deleteaccount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Deleteaccount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_deleteaccount1(inputs)
	if (locale === "en") return en_danger_deleteaccount1(inputs)
	return es_danger_deleteaccount1(inputs)
});
export { danger_deleteaccount1 as "danger_deleteAccount" }